<script setup lang="ts">

</script>

<template>
  <div class="flex flex-auto border border-mg-400 rounded-2xl p-4">
    <slot/>
  </div>
</template>

<style scoped>

</style>
